module.exports = __webpack_public_path__ + "static/media/buy_req_teach_1.4e4ac806.jpg";